import moment from "moment";

const HOURS_IN_A_DAY = 24;

export const normaliseGtfsDateTime = (date, time) => {
  if (date && time && /^\d{8}$/.test(date) && /^\d+:\d\d:\d\d$/.test(time)) {
    let normalisedTime = time;
    let dayOffset = 0;
    const [originalHour, originalMinute, originalSeconds] = time.split(":");
    if (originalHour > "23" && originalMinute && originalSeconds) {
      const parsedOriginalHour = parseInt(originalHour, 10);
      if (!isNaN(parsedOriginalHour)) {
        dayOffset = Math.floor(parsedOriginalHour / HOURS_IN_A_DAY);
        const hour = parsedOriginalHour % HOURS_IN_A_DAY;
        normalisedTime =
          `${hour}:${originalMinute}:${originalSeconds}`.padStart(8, "0");
      }
    }

    return {
      date: moment(date).add(dayOffset, "day").format("YYYYMMDD"),
      time: normalisedTime,
    };
  }
  return null;
};